import script from "./cTitle.vue?vue&type=script&lang=js"
export * from "./cTitle.vue?vue&type=script&lang=js"

import "./cTitle.vue?vue&type=style&index=0&id=7165bb66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7165bb66"],['__file',"src/components/cmp/cTitle/cTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7165bb66"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7165bb66', __exports__)) {
    api.reload('7165bb66', __exports__)
  }
  
}


export default __exports__